import { createContext, useContext, useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const I18nCtx = createContext(null);
let currentLocale = "en";
export const getLocale = () => currentLocale;

const fetchStrings = (lang) => axios.get(`${API}/i18n/${lang}`).then((r) => r.data);
export const pendingInterval = (q) => {
  const d = q.state.data;
  return (Array.isArray(d) ? d[0]?.pending : d?.pending) ? 3500 : false;
};

const initialLang = () => localStorage.getItem("ajs_lang") || (navigator.language || "en").slice(0, 2).toLowerCase();

export const I18nProvider = ({ children }) => {
  const { data: languages = [] } = useQuery({ queryKey: ["languages"], queryFn: () => axios.get(`${API}/languages`).then((r) => r.data), staleTime: Infinity });
  const [raw, setRaw] = useState(initialLang);
  const lang = !languages.length || languages.some((l) => l.code === raw) ? raw : "en";
  const en = useQuery({ queryKey: ["i18n", "en"], queryFn: () => fetchStrings("en"), staleTime: Infinity });
  const cur = useQuery({ queryKey: ["i18n", lang], queryFn: () => fetchStrings(lang), enabled: lang !== "en", staleTime: Infinity, refetchInterval: pendingInterval });
  const strings = (lang !== "en" && cur.data?.strings) || en.data?.strings || {};
  currentLocale = lang === "no" ? "nb" : lang;

  useEffect(() => { document.documentElement.lang = lang; document.documentElement.dir = lang === "ar" ? "rtl" : "ltr"; }, [lang]);
  const setLang = (l) => { localStorage.setItem("ajs_lang", l); setRaw(l); };
  const t = useCallback((k, vars = {}) => {
    const pk = vars.n !== undefined && `${k}__${new Intl.PluralRules(lang).select(Number(vars.n))}`;
    return (strings[pk] ?? strings[k] ?? k).replace(/\{(\w+)\}/g, (m, v) => (vars[v] ?? m));
  }, [strings, lang]);
  const pending = lang !== "en" && (cur.isLoading || !!cur.data?.pending);

  return (
    <I18nCtx.Provider value={{ lang, setLang, t, languages, pending, ready: !!en.data }}>
      {children}
    </I18nCtx.Provider>
  );
};

export const useI18n = () => useContext(I18nCtx);
